import { isNumber } from 'lodash';
import React, { Fragment, useEffect, useState, useImperativeHandle, forwardRef } from 'react';
import { translate } from "../../../Services/translation";

const TextInputModuleItem = forwardRef((props, _ref) => {    
    const [length, setlength] = useState(0);
    const [height, setheight] = useState(0);
    const [lengthFormatted, setlengthlengthFormatted] = useState("0,0");
    const [heightFormatted, setheightFormatted] = useState("0,0");
    const settings = {minimumFractionDigits: 1, maximumFractionDigits: 1};
    const SwedishCulture = "sv-SE";
    

    useEffect(() => {
        const item = props.inputValues ? props.inputValues.find(x => x.index === props.moduleSectionIndex) : null;
        if (item) {
           setlength(item.length);
           setlengthlengthFormatted(formatCulture(item.length));
           setheight(item.height);
           setheightFormatted(formatCulture(item.height));
        }
    }, []);

    useEffect(() => {
        const item = props.inputValues ? props.inputValues.find(x => x.index === props.moduleSectionIndex) : null;
        if (item) {
           setlength(item.length);
           setlengthlengthFormatted(formatCulture(item.length));
           setheight(item.height);
           setheightFormatted(formatCulture(item.height));
        }
    }, [props && props.inputValues]);

    const subtract = (value) => {
        if (isNumber(value)) {
            if (value > 0 ) {
                return value - 0.1;
            }
        }
        else {
            value = parseFloat(value);
            if (value > 0 ) {
                return value - 0.1;
            }
        }
        
        return "0,0";
    }

    const add = (value) => {
        if (isNumber(value)) {
            return value + 0.1;
        } 
        else {
            value = parseFloat(value);
            return value + 0.1;
        }        
    }

    const subtractLength = () => {
        const modifiedLength = subtract(length);
        setNewLengthAndUpdateParent(modifiedLength);
    }

    const addLength = () => {
        const modifiedLength = add(length);
        setNewLengthAndUpdateParent(modifiedLength);
    }

    const subtractHeight = () => {
        const modifiedHeight = subtract(height);
        setNewHeightAndUpdateParent(modifiedHeight);
    }

    const addHeight = () => {
        const modifiedHeight = add(height);
        if (modifiedHeight > 1) {
            modifiedHeight = 1;
        }
        setNewHeightAndUpdateParent(modifiedHeight);
    }

    const setNewLengthAndUpdateParent = (modifiedLength) => {
        setlength(modifiedLength);
        setlengthlengthFormatted(formatCulture(modifiedLength));
        props.onInputChange(props.moduleSectionIndex, modifiedLength.toString(), 0);
    }

    const setNewHeightAndUpdateParent = (modifiedHeight) => {
        setheight(modifiedHeight);
        setheightFormatted(formatCulture(modifiedHeight));
        props.onInputChange(props.moduleSectionIndex, 0, modifiedHeight.toString());
    }

    const getFormattedInput = (value) => {
        value = value
            .replace(",", ".")
            .replace(/[^\d,.]/, "") // Remove all characters except numericals or decimal separators.
            .trim();
            if (value === "") {
                value = "0";
            }
        return parseFloat(value).toFixed(1);
    }

    const formatCulture = (input) =>  {
        return input.toLocaleString(SwedishCulture, settings).replace(".", ",");
    }

    return(<Fragment>
        {props.showInput ? 
        <div className='item'> 
            <div className='item__remove-wrapper'>            
                <a className='remove-icon' onClick={() => {setlength(0);setheight(0); props.onShow(props.moduleSectionIndex); props.removeItem(props.moduleSectionIndex)}}></a>
            </div>     
            <p className='item__type'>{translate("straightSection")}</p>
            <div className='calculation-wrap'>
                <div className='calculation-wrap__length'>
                    <label>{translate("length")}</label> 
                    <div className='input'>
                        <button onClick={() => subtractLength()}>-</button>
                        <input type='text' step="0.1" min="0" defaultValue={lengthFormatted} key={lengthFormatted}
                        onFocus={(e) => {
                            if(e.target.value === '0,0') {
                                e.target.value = "";
                            }
                        }}
                        onBlur={(e) => {
                            const formattedInput = getFormattedInput(e.target.value);
                            setlength(formattedInput);
                            props.onInputChange(props.moduleSectionIndex, e.target.value, 0);
                            setlengthlengthFormatted(formatCulture(formattedInput));
                            }}></input>
                        <button onClick={() => addLength()}>+</button>
                    </div>
                </div>      
                <div className='calculation-wrap__height'>
                    <label>{translate("height")}</label> 
                    <div className='input'>
                        <button onClick={() => subtractHeight()}>-</button>
                        <input type='text' step="0.1" min="0" defaultValue={heightFormatted} key={heightFormatted} max="1"
                        onFocus={(e) => {
                            if(e.target.value === '0,0') {
                                e.target.value = "";
                            }
                        }}
                        onBlur={(e) => {
                            const formattedInput = getFormattedInput(e.target.value);
                            setheight(formattedInput);
                            props.onInputChange(props.moduleSectionIndex, 0, e.target.value);
                            setheightFormatted(formatCulture(formattedInput));                        
                        }}></input>
                        <button onClick={() => addHeight()}>+</button>
                    </div>
                </div>          
            </div>
            {props.validations && props.validations.find(x => x.indexValue === props.moduleSectionIndex) &&
                <div className='item__error-message'>{props.validations.find(x => x.indexValue === props.moduleSectionIndex).message}</div>} 
        </div> :
        <div className='select'>
            <a className='select__icon'
            onClick={() => {props.openedItems && props.moduleSectionIndex !==0 && props.openedItems.indexOf(props.moduleSectionIndex - 1) === -1 ?
                "" : props.onShow(props.moduleSectionIndex, true);}}></a>
            <p className='select__text'>{translate("addSection")}</p>
        </div>}
    </Fragment>)
})

export default TextInputModuleItem;